import image1 from "../assets/images/image1.png";
import image2 from "../assets/images/image2.png";
import image3 from "../assets/images/image3.png";
import image4 from "../assets/images/image4.png";
import image5 from "../assets/images/image5.png";
import image6 from "../assets/images/image6.png";
import image7 from "../assets/images/image7.png";
import image_patient1 from "../assets/images/image_patient1.png";
import image_patient2 from "../assets/images/image_patient2.png";
import image_patient3 from "../assets/images/image_patient3.png";
import image_patient4 from "../assets/images/image_patient4.png";
import image_patient5 from "../assets/images/image_patient5.png";
import image_patient6 from "../assets/images/image_patient6.png";

export const counseleeData = [
  {
    id: 1,
    patientName: "Engin Serdar",
    day: "Dec 12th at 2:30pm",
    isDone: true,
    myDoctor: "Asst. Prof.Emir Akın",
    image: image_patient1,
  },
  {
    id: 2,
    patientName: "Ebrar Elif",
    day: "Dec 13th at 1:30pm",
    isDone: false,
    myDoctor: "Asst. Prof.Emir Akın",
    image: image_patient2,
  },
  {
    id: 3,
    patientName: "Fatih Aslan",
    day: "Dec 14th at 3:00pm",
    isDone: false,
    myDoctor: "Prof.Aysa Dizdar",
    image: image_patient3,
  },
  {
    id: 4,
    patientName: "İpek Bilir",
    day: "Dec 12th at 2:30pm",
    isDone: true,
    myDoctor: "Psk. Neva Yılmaz",
    image: image_patient4,
  },
  {
    id: 5,
    patientName: "Hilal Siner",
    day: "Dec 13th at 1:30pm",
    isDone: false,
    myDoctor: "Psk. Sena Adil",
    image: image_patient5,
  },
  {
    id: 6,
    patientName: "Ayşe Güler",
    day: "Dec 14th at 3:00pm",
    isDone: true,
    myDoctor: "Psk.Alina Berrin Akın",
    image: image_patient6,
  },
];

export const doctorData = [
  {
    id: 1,
    doctorName: "Prof. Aysa Dizdar",
    doctorImg: image1,
  },
  {
    id: 2,
    doctorName: "Psk. Alina Berrin Akın",
    doctorImg: image2,
  },
  {
    id: 3,
    doctorName: "Psk. Sena Adil",
    doctorImg: image3,
  },
  {
    id: 4,
    doctorName: "Psk. Neva Yılmaz",
    doctorImg: image4,
  },
  {
    id: 5,
    doctorName: "Asst. Prof. Emir Akın",
    doctorImg: image5,
  },
  {
    id: 6,
    doctorName: "Psk. Müge Sezen",
    doctorImg: image6,
  },
  {
    id: 7,
    doctorName: "Psk. Ayhan Kemer",
    doctorImg: image7,
  },
];
